
import { defineComponent, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useCookie } from 'vue-cookie-next'

import AuthenticationRepository from '@/repositories/AuthenticationRepository'

export default defineComponent({
  name: 'TheHeader',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    const cookie = useCookie()

    const isLoggedIn = ref(false)
    const isEventPage = ref(false)

    watch(
      () => route,
      () => {
        isLoggedIn.value = cookie.getCookie('user_id') != null

        const eventPath = '/event'
        isEventPage.value = route.path.match(eventPath) ? true : false
      },
      { immediate: true, deep: true }
    )

    const logout = async () => {
      try {
        const res = await AuthenticationRepository.logout()

        if (res.status === 200) {
          cookie.removeCookie('user_id')

          router.push({ name: 'login' })

          store.dispatch('addFlashMessage',{
            type: 'success',
            message: 'ログアウトしました'
          })
        }
      } catch (error) {
        //
      }
    }

    const HOST_PATH = ref(process.env.VUE_APP_PUBLIC_HOST + process.env.VUE_APP_PUBLIC_PATH)

    return {
      isLoggedIn,
      isEventPage,

      logout,

      HOST_PATH
    }

  }
})
